import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'

import { HEADER_NAV_ITEM, headerNavItemData } from '@lyrahealth-inc/shared-app-logic'

import { HeaderProps } from './Header'
import { CaregivingIcon } from '../../atoms/icons/CaregivingIcon'
import { EssentialsIcon } from '../../atoms/icons/EssentialsIcon'
import { HomeIcon } from '../../atoms/icons/HomeIcon'
import { getTabItemIcon, tID } from '../../utils'
import { LightHomeToolbar } from '../lightHomeToolbar/LightHomeToolbar'

/** Main header for the Lyra app (web) */
export const Header: FunctionComponent<HeaderProps> = ({
  isInternationalUser,
  shouldShowCareNavigatorHeaderEntrypoint,
  careNavigatorModal,
  careNavigatorEntryPoint,
  headerNavMenuProps,
  mainNavItemsProps,
  currentPathname,
  currentScreen,
  onLogoPressed,
  shouldShowNavMenu = true,
  shouldShowBack,
  onBackPressed,
  title,
  showMessages,
  messagesPopover,
  onMessagesPressed,
  unreadMessages,
  favoritedProvidersEntrypointNavProps,
  shouldShowLoginAndSignUpButtons,
  onLoginPressed,
  onSignUpPressed,
  shouldShowReferral,
  onReferralPressed,
  isTransparentBackground,
  shouldOverlapPageContent,
  shouldShowLanguageSelector,
  onLanguageSelectorGetHelpPress,
  beforeLaunch,
  showAICoachIcon,
}) => {
  const { formatMessage } = useIntl()

  const navItems = [
    {
      id: HEADER_NAV_ITEM.HOME,
      text: formatMessage(headerNavItemData[HEADER_NAV_ITEM.HOME].label),
      onPressItem: mainNavItemsProps?.handleHomePress,
      activePathnames: headerNavItemData[HEADER_NAV_ITEM.HOME].activePathnames,
      activeScreens: headerNavItemData[HEADER_NAV_ITEM.HOME].activeScreenNames,
      condition: mainNavItemsProps?.shouldShowHome,
      icon: (isActive: boolean) => getTabItemIcon({ isActive, IconComponent: HomeIcon, testID: 'HomeIcon' }),
    },
    {
      id: HEADER_NAV_ITEM.CARE,
      text: formatMessage(headerNavItemData[HEADER_NAV_ITEM.CARE].label),
      onPressItem: mainNavItemsProps?.handleCarePress,
      activePathnames: headerNavItemData[HEADER_NAV_ITEM.CARE].activePathnames,
      activeScreens: headerNavItemData[HEADER_NAV_ITEM.CARE].activeScreenNames,
      condition: mainNavItemsProps?.shouldShowCare,
      icon: (isActive: boolean) =>
        getTabItemIcon({ isActive, IconComponent: CaregivingIcon, testID: 'CaregivingIcon' }),
    },
    {
      id: HEADER_NAV_ITEM.ESSENTIALS,
      text: formatMessage(headerNavItemData[HEADER_NAV_ITEM.ESSENTIALS].label),
      onPressItem: mainNavItemsProps?.handleEssentialsPress,
      activePathnames: headerNavItemData[HEADER_NAV_ITEM.ESSENTIALS].activePathnames,
      activeScreens: headerNavItemData[HEADER_NAV_ITEM.ESSENTIALS].activeScreenNames,
      condition: mainNavItemsProps?.shouldShowEssentials,
      icon: (isActive: boolean) =>
        getTabItemIcon({ isActive, IconComponent: EssentialsIcon, testID: 'EssentialsIcon' }),
    },
  ]

  return (
    <LightHomeToolbar
      testID={tID('AppHeader')}
      isInternational={isInternationalUser}
      shouldShowCareNavigatorHeaderEntrypoint={shouldShowCareNavigatorHeaderEntrypoint}
      careNavigatorModal={careNavigatorModal}
      careNavigatorEntryPoint={careNavigatorEntryPoint}
      showNavMenu={shouldShowNavMenu}
      headerNavMenuProps={headerNavMenuProps}
      navItems={navItems}
      currentPathname={currentPathname}
      currentScreen={currentScreen}
      onLogoPressed={onLogoPressed}
      showBack={shouldShowBack}
      onBackPressed={onBackPressed}
      title={title}
      showMessages={showMessages}
      onMessagesPressed={onMessagesPressed}
      messagesPopover={messagesPopover}
      unreadMessages={unreadMessages}
      favoritedProvidersEntrypointNavProps={favoritedProvidersEntrypointNavProps}
      shouldShowLoginAndSignUpButtons={shouldShowLoginAndSignUpButtons}
      onLoginPressed={onLoginPressed}
      onSignUpPressed={onSignUpPressed}
      shouldShowReferral={shouldShowReferral}
      onReferralPressed={onReferralPressed}
      isTransparentBackground={isTransparentBackground}
      shouldOverlapPageContent={shouldOverlapPageContent}
      shouldShowLanguageSelector={shouldShowLanguageSelector}
      onLanguageSelectorGetHelpPress={onLanguageSelectorGetHelpPress}
      beforeLaunch={beforeLaunch}
      showAICoachIcon={showAICoachIcon}
    />
  )
}
